import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TRANSLATE_MODAL } from '@/src/modules/CampaignsModule/components/CampaignsModal/CreateEditCampaigns/constants';

import { useCampaign } from '@/modules/CampaignsModule/hooks/useCampaigns';
import { ICampaignListPayload } from '@/modules/CampaignsModule/interfaces/Campaigns';

export const useMoveActions = () => {
  const { t } = useTranslation();
  const { getListAll, loading: loadingCampaign } = useCampaign();

  useEffect(() => {
    const payload: ICampaignListPayload = { sortField: 'name', sortOrder: 'asc' };
    void getListAll(payload);
  }, [getListAll]);

  const VALIDATION_RULES = useMemo(
    () => ({
      campaigns: {
        required: {
          value: true,
          message: t(`${TRANSLATE_MODAL}.INPUTS_ERROR.required`),
        },
      },
    }),
    [t]
  );

  return {
    loadingCampaign,
    VALIDATION_RULES,
  };
};
